// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= TRADE SIGNALS SECTION ================= */

.tradeSignalsPanel {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Main Grid */

.tradeSignalsGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  flex: 1 1;
  align-items: stretch;
  min-height: 0;
}

/* Signal Card */

.tradeSignalCard {
  position: relative;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(177, 136, 0, 0.18);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.015)),
    rgba(7, 9, 14, 0.92);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.055),
    0 18px 40px rgba(0, 0, 0, 0.28);
}

.tradeSignalCard::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.6;
}

.tradeSignalCard.argos::before {
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.22), transparent 42%),
    radial-gradient(circle at bottom right, rgba(95, 73, 0, 0.16), transparent 45%);
}

.tradeSignalCard.gemic::before {
  background:
    radial-gradient(circle at top left, rgba(70, 120, 255, 0.15), transparent 42%),
    radial-gradient(circle at bottom right, rgba(177, 136, 0, 0.08), transparent 45%);
}

.tradeSignalCard.acce::before {
  background:
    radial-gradient(circle at top left, rgba(255, 112, 24, 0.14), transparent 42%),
    radial-gradient(circle at bottom right, rgba(177, 136, 0, 0.1), transparent 45%);
}

/* Header */

.tradeSignalHeader {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
}

.tradeSignalHeader h3 {
  margin: 0;
  color: #f6f2e7;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.tradeSignalHeader p {
  margin: 4px 0 0;
  max-width: 190px;
  color: rgba(246, 242, 231, 0.58);
  font-size: 12px;
  line-height: 1.35;
}

/* Status Badge */

.signalStatusBadge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.signalStatusBadge.posted {
  color: #07100a;
  background: linear-gradient(135deg, #c9a227, #f1d36a);
  box-shadow: 0 0 18px rgba(177, 136, 0, 0.24);
}

.signalStatusBadge.waiting {
  color: rgba(246, 242, 231, 0.72);
  border: 1px solid rgba(246, 242, 231, 0.12);
  background: rgba(255, 255, 255, 0.055);
}

/* Meta */

.tradeSignalMeta {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 0 16px 14px;
  padding: 10px 12px;
  border: 1px solid rgba(246, 242, 231, 0.08);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.22);
}

.tradeSignalMeta span {
  color: rgba(246, 242, 231, 0.5);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.tradeSignalMeta strong {
  color: #f1d36a;
  font-size: 14px;
  font-weight: 800;
}

/* Trade Box */

.tradeBox {
  position: relative;
  z-index: 1;
  flex: 1 1;
  margin: 0 16px 16px;
  padding: 14px;
  border: 1px solid rgba(177, 136, 0, 0.22);
  border-radius: 14px;
  background:
    linear-gradient(180deg, rgba(177, 136, 0, 0.12), rgba(177, 136, 0, 0.035)),
    rgba(0, 0, 0, 0.26);
}

.tradeBox.pending {
  border-color: rgba(246, 242, 231, 0.09);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.018)),
    rgba(0, 0, 0, 0.22);
}

.tradeBox > span {
  display: block;
  margin-bottom: 5px;
  color: rgba(246, 242, 231, 0.5);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.tradeBox > strong {
  display: block;
  color: #f6f2e7;
  font-size: 15px;
  font-weight: 850;
  line-height: 1.25;
}

.tradeBox > p {
  margin: 7px 0 0;
  color: rgba(246, 242, 231, 0.56);
  font-size: 12px;
  line-height: 1.45;
}

/* Trade Stats */

.tradeStats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.tradeStats div {
  min-width: 0;
  padding: 10px;
  border: 1px solid rgba(246, 242, 231, 0.075);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.24);
}

.tradeStats span {
  display: block;
  margin-bottom: 4px;
  color: rgba(246, 242, 231, 0.45);
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.tradeStats strong {
  display: block;
  color: #f6f2e7;
  font-size: 13px;
  font-weight: 850;
}

.tradeStats strong.positive {
  color: #64f0a2;
}

/* Responsive */

@media (max-width: 1120px) {
  .tradeSignalsGrid {
    grid-template-columns: 1fr;
  }

  .tradeSignalHeader p {
    max-width: none;
  }
}

@media (max-width: 560px) {
  .tradeSignalHeader {
    flex-direction: column;
  }

  .signalStatusBadge {
    align-self: flex-start;
  }

  .tradeStats {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/TradeSignalsSection.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAO;EACP,oBAAoB;EACpB,aAAa;AACf;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB;;wBAEsB;EACtB;;mCAEiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;;mFAEiF;AACnF;;AAEA;EACE;;qFAEmF;AACrF;;AAEA;EACE;;oFAEkF;AACpF;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;;AAEjB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB;;uBAEqB;AACvB;;AAEA;EACE,uCAAuC;EACvC;;uBAEqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ================= TRADE SIGNALS SECTION ================= */\n\n.tradeSignalsPanel {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n/* Main Grid */\n\n.tradeSignalsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  flex: 1;\n  align-items: stretch;\n  min-height: 0;\n}\n\n/* Signal Card */\n\n.tradeSignalCard {\n  position: relative;\n  min-width: 0;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(177, 136, 0, 0.18);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.015)),\n    rgba(7, 9, 14, 0.92);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.055),\n    0 18px 40px rgba(0, 0, 0, 0.28);\n}\n\n.tradeSignalCard::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.6;\n}\n\n.tradeSignalCard.argos::before {\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.22), transparent 42%),\n    radial-gradient(circle at bottom right, rgba(95, 73, 0, 0.16), transparent 45%);\n}\n\n.tradeSignalCard.gemic::before {\n  background:\n    radial-gradient(circle at top left, rgba(70, 120, 255, 0.15), transparent 42%),\n    radial-gradient(circle at bottom right, rgba(177, 136, 0, 0.08), transparent 45%);\n}\n\n.tradeSignalCard.acce::before {\n  background:\n    radial-gradient(circle at top left, rgba(255, 112, 24, 0.14), transparent 42%),\n    radial-gradient(circle at bottom right, rgba(177, 136, 0, 0.1), transparent 45%);\n}\n\n/* Header */\n\n.tradeSignalHeader {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px 12px;\n}\n\n.tradeSignalHeader h3 {\n  margin: 0;\n  color: #f6f2e7;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.tradeSignalHeader p {\n  margin: 4px 0 0;\n  max-width: 190px;\n  color: rgba(246, 242, 231, 0.58);\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n/* Status Badge */\n\n.signalStatusBadge {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.signalStatusBadge.posted {\n  color: #07100a;\n  background: linear-gradient(135deg, #c9a227, #f1d36a);\n  box-shadow: 0 0 18px rgba(177, 136, 0, 0.24);\n}\n\n.signalStatusBadge.waiting {\n  color: rgba(246, 242, 231, 0.72);\n  border: 1px solid rgba(246, 242, 231, 0.12);\n  background: rgba(255, 255, 255, 0.055);\n}\n\n/* Meta */\n\n.tradeSignalMeta {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 16px 14px;\n  padding: 10px 12px;\n  border: 1px solid rgba(246, 242, 231, 0.08);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.tradeSignalMeta span {\n  color: rgba(246, 242, 231, 0.5);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.tradeSignalMeta strong {\n  color: #f1d36a;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n/* Trade Box */\n\n.tradeBox {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  margin: 0 16px 16px;\n  padding: 14px;\n  border: 1px solid rgba(177, 136, 0, 0.22);\n  border-radius: 14px;\n  background:\n    linear-gradient(180deg, rgba(177, 136, 0, 0.12), rgba(177, 136, 0, 0.035)),\n    rgba(0, 0, 0, 0.26);\n}\n\n.tradeBox.pending {\n  border-color: rgba(246, 242, 231, 0.09);\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.018)),\n    rgba(0, 0, 0, 0.22);\n}\n\n.tradeBox > span {\n  display: block;\n  margin-bottom: 5px;\n  color: rgba(246, 242, 231, 0.5);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.tradeBox > strong {\n  display: block;\n  color: #f6f2e7;\n  font-size: 15px;\n  font-weight: 850;\n  line-height: 1.25;\n}\n\n.tradeBox > p {\n  margin: 7px 0 0;\n  color: rgba(246, 242, 231, 0.56);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n/* Trade Stats */\n\n.tradeStats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.tradeStats div {\n  min-width: 0;\n  padding: 10px;\n  border: 1px solid rgba(246, 242, 231, 0.075);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.24);\n}\n\n.tradeStats span {\n  display: block;\n  margin-bottom: 4px;\n  color: rgba(246, 242, 231, 0.45);\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.tradeStats strong {\n  display: block;\n  color: #f6f2e7;\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.tradeStats strong.positive {\n  color: #64f0a2;\n}\n\n/* Responsive */\n\n@media (max-width: 1120px) {\n  .tradeSignalsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .tradeSignalHeader p {\n    max-width: none;\n  }\n}\n\n@media (max-width: 560px) {\n  .tradeSignalHeader {\n    flex-direction: column;\n  }\n\n  .signalStatusBadge {\n    align-self: flex-start;\n  }\n\n  .tradeStats {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
